export const PWA_INSTALL_TOAST_KEY = 'echo_jham_booking_pwa_install_toast_shown_v1';
export const PWA_INSTALL_TIMEOUT_MS = 60000;

export const isStandaloneDisplayMode = (win = window) => {
  const mediaStandalone = typeof win.matchMedia === 'function'
    && Boolean(win.matchMedia('(display-mode: standalone)')?.matches);
  return Boolean(mediaStandalone || win.navigator?.standalone);
};

export const isIosDevice = (win = window) => {
  const ua = String(win.navigator?.userAgent || '');
  if (/iphone|ipad|ipod/i.test(ua)) return true;
  // iPadOS desktop UA
  return win.navigator?.platform === 'MacIntel' && Number(win.navigator?.maxTouchPoints || 0) > 1;
};

export const isInAppBrowser = (win = window) => {
  const ua = String(win.navigator?.userAgent || '');
  return /FBAN|FBAV|Instagram|Line\/|Twitter|LinkedInApp|Snapchat|MicroMessenger|WebView|(;\s*wv\))/i.test(ua);
};

export const hasShownInstallSuccessToast = () => {
  try {
    return window.localStorage.getItem(PWA_INSTALL_TOAST_KEY) === '1';
  } catch {
    return false;
  }
};

export const markInstallSuccessToastShown = () => {
  try {
    window.localStorage.setItem(PWA_INSTALL_TOAST_KEY, '1');
  } catch {
    // Ignore storage failures (private mode, etc.).
  }
};
